/**
 * Enum for medical order status values
 */
export enum MedicalOrderStatus {
  OrderCompletedByAgent = "order_completed_by_agent",
  OrderInProgress = "order_in_progress",
  YetToStartWorkOnOrder = "yet_to_start_work_on_order",
}

/**
 * Array of medical order status values for agentic type
 */
export const AGENTIC_MEDICAL_ORDER_STATUSES: MedicalOrderStatus[] = [
  MedicalOrderStatus.OrderCompletedByAgent,
  MedicalOrderStatus.OrderInProgress,
];

/**
 * Array of medical order status values for human type
 */
export const HUMAN_MEDICAL_ORDER_STATUSES: MedicalOrderStatus[] = [
  MedicalOrderStatus.YetToStartWorkOnOrder,
];
